export class Voucher {
    code:string;
    useDate:Date;

    constructor(voucher:any) {
        this.code = voucher.code;
        this.useDate = voucher.useDate;
    }
}